<template>
  <v-container class="guide">
    <h1 class="guide__title">{{ t("title") }}</h1>

    <div v-if="loading" class="text-center py-10">
      <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
    </div>

    <template v-else>
      <div class="guide__main">
        <v-icon size="44" color="primary" class="guide__main-icon">mdi-book-open-page-variant-outline</v-icon>
        <div class="guide__main-text">
          <div class="guide__main-title">{{ t("instruction") }}</div>
          <p class="mb-0">{{ url ? t("instructionText") : t("instructionSoon") }}</p>
        </div>
        <v-btn v-if="url" depressed large color="primary" :href="url" target="_blank" rel="noopener" class="guide__main-btn">
          {{ t("open") }}
          <v-icon right>mdi-open-in-new</v-icon>
        </v-btn>
      </div>

      <h2 class="guide__subtitle">{{ t("updates") }}</h2>
      <p v-if="!updates.length" class="grey--text">{{ t("noUpdates") }}</p>
      <article v-for="item in updates" :key="item.id" class="guide__update" :class="{ 'guide__update--new': item.is_new }">
        <div class="d-flex flex-wrap align-center guide__update-meta">
          <span v-if="item.is_new" class="guide__update-new">{{ t("new") }}</span>
          <span>{{ dateOf(item.published_at) }}</span>
        </div>
        <div class="guide__update-title">{{ item.title }}</div>
        <p v-if="item.body" class="guide__update-body">{{ item.body }}</p>
        <a v-if="item.link" :href="item.link" target="_blank" rel="noopener" class="guide__update-link">
          {{ t("more") }} <v-icon small color="primary">mdi-open-in-new</v-icon>
        </a>
      </article>
    </template>
  </v-container>
</template>

<script>
import ApiClient from "@/libs/http-client";

export default {
  name: "PsychologistGuide",
  metaInfo() {
    return { title: "Платформа / " + this.t("title") };
  },
  data() {
    return {
      loading: true,
      url: null,
      updates: [],
    };
  },
  mounted() {
    ApiClient.get("api/psychologists/me/guide")
      .then((response) => {
        const data = response.data.data;
        this.url = data.url;
        this.updates = data.updates;
        // the "new" marks stay on the page, the menu counter goes away
        if (data.unread) {
          return ApiClient.post("api/psychologists/me/guide/seen").then(() => {
            this.$root.$emit("menu-counters-refresh");
          });
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    t(key) {
      return this.$vuetify.lang.t(`$vuetify.main.psychologistDashboard.guide.${key}`);
    },
    dateOf(value) {
      return new Date(value).toLocaleDateString("uk-UA", { day: "numeric", month: "long", year: "numeric" });
    },
  },
};
</script>

<style lang="scss" scoped>
.guide {
  max-width: 900px;
  padding-top: 40px;
  padding-bottom: 60px;
  color: #575756;
}
.guide__title {
  color: #00A3B7;
  font-size: 25px;
  font-weight: 500;
}
.guide__main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px 24px;
  margin-top: 24px;
  padding: 26px 28px;
  border: 2px solid #00A3B7;
  border-radius: 14px;
  background: #EEF8FA;
}
.guide__main-icon {
  flex: none;
}
.guide__main-text {
  flex: 1 1 260px;
  font-size: 16px;
}
.guide__main-title {
  margin-bottom: 4px;
  font-size: 20px;
  font-weight: 500;
}
.guide__main-btn {
  flex: none;
}
.guide__subtitle {
  margin: 40px 0 16px;
  font-size: 20px;
  font-weight: 500;
}
.guide__update {
  margin-bottom: 14px;
  padding: 18px 22px;
  border: 1px solid #D9E4EB;
  border-radius: 12px;
  background: #fff;
  &--new {
    border-color: #00A3B7;
  }
}
.guide__update-meta {
  gap: 6px 14px;
  color: #868686;
  font-size: 14px;
}
.guide__update-new {
  color: #E5484D;
  font-weight: 500;
}
.guide__update-title {
  margin-top: 6px;
  font-size: 18px;
  font-weight: 500;
  overflow-wrap: break-word;
}
.guide__update-body {
  margin: 8px 0 0;
  white-space: pre-line;
  overflow-wrap: break-word;
}
.guide__update-link {
  display: inline-block;
  margin-top: 10px;
  text-decoration: none;
}
@media (max-width: 600px) {
  .guide__main {
    padding: 20px 18px;
  }
  .guide__main-btn {
    width: 100%;
  }
}
</style>
